import { useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";
import { Lightbulb, Send } from "lucide-react";

export default function SuggestForm() {
  const [title, setTitle] = useState("");
  const [network, setNetwork] = useState("");
  const [note, setNote] = useState("");
  const [submitterName, setSubmitterName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!title.trim()) return;
    setSubmitting(true);
    try {
      await api.post("/suggestions", {
        title: title.trim(),
        network: network.trim() || null,
        note: note.trim() || null,
        submitter_name: submitterName.trim() || null,
      });
      toast.success("Mulțumim! Sugestia ta a ajuns la noi 🎉");
      setTitle(""); setNetwork(""); setNote(""); setSubmitterName("");
      setSent(true);
      setTimeout(() => setSent(false), 4000);
    } catch {
      toast.error("Ceva nu a mers. Mai încearcă!");
    }
    setSubmitting(false);
  };

  return (
    <section className="relative border-y-4 border-[#00e5ff]/50 bg-[#0d1410] overflow-hidden" data-testid="suggest-section">
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 70% 20%, rgba(0,229,255,0.10), transparent 55%), radial-gradient(ellipse at 30% 90%, rgba(255,47,167,0.08), transparent 60%)",
        }}
      />
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-[1fr_1.2fr] gap-8 items-start">
        <div>
          <div className="inline-flex items-center gap-2 bg-yellow-300 border-4 border-slate-900 rounded-full px-4 py-1 mb-4 shadow-brutal-sm">
            <Lightbulb className="w-4 h-4" strokeWidth={3} />
            <span className="font-black uppercase text-xs tracking-widest">Ai o idee?</span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl font-black text-slate-900 text-bubble-sm leading-tight">
            Sugerează<br /><span className="text-pink-500">un Desen</span>
          </h2>
          <p className="mt-4 text-slate-700 font-medium">
            Lipsește un serial preferat din colecție? Spune-ne ce ai vrea să adăugăm și echipa Desene2000 îl pune pe listă.
          </p>
        </div>

        <form onSubmit={submit} className="bg-white border-4 border-slate-900 rounded-2xl p-6 shadow-brutal space-y-3" data-testid="suggest-form">
          <div>
            <label className="text-xs font-black uppercase tracking-widest text-slate-700">Titlul desenului *</label>
            <input
              data-testid="suggest-title-input"
              required
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Ex: Codename: Kids Next Door"
              className="mt-1 w-full px-4 py-3 border-4 border-slate-900 rounded-xl bg-yellow-50 focus:ring-4 focus:ring-pink-400 outline-none font-bold"
            />
          </div>
          <div>
            <label className="text-xs font-black uppercase tracking-widest text-slate-700">Canal (opțional)</label>
            <input
              data-testid="suggest-network-input"
              value={network}
              onChange={(e) => setNetwork(e.target.value)}
              placeholder="Cartoon Network, Nickelodeon..."
              className="mt-1 w-full px-4 py-3 border-4 border-slate-900 rounded-xl bg-yellow-50 focus:ring-4 focus:ring-pink-400 outline-none font-bold"
            />
          </div>
          <div>
            <label className="text-xs font-black uppercase tracking-widest text-slate-700">De ce ți-ar plăcea? (opțional)</label>
            <textarea
              data-testid="suggest-note-input"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              rows={2}
              maxLength={500}
              placeholder="Spune-ne ce te-a făcut să iubești serialul..."
              className="mt-1 w-full px-4 py-3 border-4 border-slate-900 rounded-xl bg-yellow-50 focus:ring-4 focus:ring-pink-400 outline-none font-bold"
            />
          </div>
          <div>
            <label className="text-xs font-black uppercase tracking-widest text-slate-700">Numele tău (opțional)</label>
            <input
              data-testid="suggest-name-input"
              value={submitterName}
              onChange={(e) => setSubmitterName(e.target.value)}
              placeholder="Cum ne semnăm sugestia ta"
              className="mt-1 w-full px-4 py-3 border-4 border-slate-900 rounded-xl bg-yellow-50 focus:ring-4 focus:ring-pink-400 outline-none font-bold"
            />
          </div>
          <button
            type="submit"
            disabled={submitting || sent}
            data-testid="suggest-submit-btn"
            className="w-full px-6 py-3 bg-pink-500 text-white border-4 border-slate-900 rounded-full font-black uppercase tracking-wider shadow-brutal hover-press disabled:opacity-60 inline-flex items-center justify-center gap-2"
          >
            <Send className="w-4 h-4" strokeWidth={3} />
            {sent ? "Trimis! 🎉" : submitting ? "Se trimite..." : "Trimite Sugestia"}
          </button>
        </form>
      </div>
    </section>
  );
}
